import { PeopleSummaryData } from 'api/gql-utils/employeeOnboardingGql/types';
import { PeopleTabValue, VisiblePeopleTabValue } from '../types';

export const activePeopleApiParamsMap: Partial<Record<PeopleTabValue, boolean>> = {
  active: true,
  employees: true,
  contractors: true,
  dismissed: false,
};

export const employeeTypePeopleApiParamsMap: Partial<Record<PeopleTabValue, string>> = {
  employees: 'employee',
  contractors: 'contractor',
};

export const getPeopleTableHeading = (
  contractorsTitleCase: string,
): Record<PeopleTabValue, string> => {
  return {
    active: 'Active Users',
    employees: 'Active Employees',
    contractors: `Active ${contractorsTitleCase}`,
    drafts: 'Draft Employees',
    dismissed: 'Dismissed Employees',
    search: 'Search Results',
  };
};

const employeeTypeColumnTabs: PeopleTabValue[] = ['employees', 'drafts', 'dismissed', 'search'];

const employeeTypeFilterTabs: PeopleTabValue[] = ['employees', 'drafts', 'dismissed'];

export const showsEmployeeTypeColumn = (tab: PeopleTabValue): boolean =>
  employeeTypeColumnTabs.includes(tab);

export const showsEmployeeTypeFilter = (tab: PeopleTabValue): boolean =>
  employeeTypeFilterTabs.includes(tab);

const visiblePeopleTabValues: VisiblePeopleTabValue[] = [
  'active',
  'employees',
  'contractors',
  'drafts',
  'dismissed',
];

export const isVisiblePeopleTab = (value?: string | null): value is VisiblePeopleTabValue =>
  !!value && visiblePeopleTabValues.includes(value as VisiblePeopleTabValue);

export const getPeopleTabs = (
  contractorsTitleCase: string,
): Array<{
  label: string;
  value: VisiblePeopleTabValue;
  key: keyof PeopleSummaryData;
}> => {
  return [
    {
      label: 'Active',
      value: 'active',
      key: 'activeUsers',
    },
    {
      label: 'Employees',
      value: 'employees',
      key: 'activeEmployees',
    },
    {
      label: contractorsTitleCase,
      value: 'contractors',
      key: 'activeContractors',
    },
    {
      label: 'Drafts',
      value: 'drafts',
      key: 'draftEmployees',
    },
    {
      label: 'Dismissed',
      value: 'dismissed',
      key: 'dismissed',
    },
  ];
};
